import { AlertTriangle, CheckCircle2, Info, OctagonAlert } from "lucide-react";

import { cx } from "@/lib/cx";

type Tone = "danger" | "warning" | "info" | "success";

const tones: Record<Tone, { className: string; icon: React.ReactNode }> = {
  danger: {
    className:
      "border-[color-mix(in_oklab,var(--c-danger)_40%,transparent)] bg-[color-mix(in_oklab,var(--c-danger)_8%,var(--c-surface))]",
    icon: <OctagonAlert className="size-4 text-danger" />,
  },
  warning: {
    className:
      "border-[color-mix(in_oklab,var(--c-warning)_45%,transparent)] bg-[color-mix(in_oklab,var(--c-warning)_10%,var(--c-surface))]",
    icon: <AlertTriangle className="size-4 text-warning" />,
  },
  info: {
    className: "border-line bg-surface",
    icon: <Info className="size-4 text-info" />,
  },
  success: {
    className:
      "border-[color-mix(in_oklab,var(--c-success)_40%,transparent)] bg-[color-mix(in_oklab,var(--c-success)_8%,var(--c-surface))]",
    icon: <CheckCircle2 className="size-4 text-success" />,
  },
};

export function Banner({
  tone = "info",
  title,
  children,
  action,
  className,
}: {
  tone?: Tone;
  title?: React.ReactNode;
  children?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      role={tone === "danger" ? "alert" : "status"}
      className={cx(
        "flex items-start gap-3 rounded-[var(--radius-panel)] border px-4 py-3 text-sm",
        tones[tone].className,
        className,
      )}
    >
      <span className="mt-0.5 shrink-0">{tones[tone].icon}</span>
      <div className="min-w-0 flex-1">
        {title && <p className="font-medium">{title}</p>}
        {children && <div className={cx(Boolean(title) && "mt-0.5", "text-muted")}>{children}</div>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
